import { JsonPatchOperation } from '@core/data/models/json-patch.model';

export interface TextCombination {
  id: number;
  name: string;
  textCount: number;
  damageCategoryId?: number;
  gdvDamageKindId?: number;
  createdAt?: Date;
  updatedAt?: Date;
  textCombinationTemplateData: { id: number; orderSequence: number }[];
}

export interface TextCombinationView extends TextCombination {
  damageCategoryDescription?: string;
  gdvDamageKindDescription?: string;
}

export function toPatchOperations(
  changes: Partial<TextCombination>
): JsonPatchOperation[] {
  const operations: JsonPatchOperation[] = [];

  Object.entries(changes).forEach(([key, value]) => {
    if (value !== undefined) {
      operations.push({
        op: 'replace',
        path: `/${key}`,
        value: value,
      });
    }
  });

  return operations;
}
